import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { ActiveScreeningPrompt, HttpResponse } from "@/types";

export const ACTIVE_SCREENS_QUERY_KEY = ["active-screens"];

export function useGetActiveScreens() {
  return useQuery({
    queryKey: ACTIVE_SCREENS_QUERY_KEY,
    refetchInterval: 30_000, // refetch active screens every 30s
    queryFn: async () => {
      const path = "interviews/active-screens";
      const res = await guacHttpClient.get<
        ActiveScreeningPrompt[],
        HttpResponse<ActiveScreeningPrompt[]>
      >(path);

      return res.data;
    },
  });
}
